import { BeconUserTypes } from "@becon-team/becon-fe-lib/my-types";
import { zDateString } from "@becon-team/becon-fe-lib/my-zod";
import { HairTypeEnum } from "modules/account/services/account.dto";
import { z } from "zod";

export const UserDtoSchema = z.object({
  userId: z.string(),
  deposit: z.number(),
  assignedAccountId: z.string().nullable(),
  nickname: z.string(),
  phoneNumber: z.string(),
  gender: z.nativeEnum(BeconUserTypes.UserGenderEnum).nullable(),
  birth: z.string().nullable(),
  privacyTerm: z.boolean(),
  sensitivityTerm: z.boolean(),
  serviceTerm: z.boolean(),
  marketingAgreement: z.boolean(),
  memo: z.string().nullable(),
  regDate: zDateString,
});
export type UserDto = z.infer<typeof UserDtoSchema>;

export const UserItemDtoSchema = UserDtoSchema.omit({ deposit: true, memo: true });
export type UserItemDto = z.infer<typeof UserItemDtoSchema>;

// ========== health inquiry ========== //
export enum YesOrNoEnum {
  NO = "NO",
  YES = "YES",
}
export type YesOrNo = keyof typeof YesOrNoEnum;

export enum NoToMoreThenOneEnum {
  NO = "NO",
  ONE = "ONE",
  MORE_THAN_ONE = "MORE_THAN_ONE",
}
export type NoToMoreThenOne = keyof typeof NoToMoreThenOneEnum;

export enum NoToMoreThenThreeEnum {
  NO = "NO",
  LESS_THAN_TWO = "LESS_THAN_TWO",
  MORE_THAN_THREE = "MORE_THAN_THREE",
}
export type NoToMoreThenThree = keyof typeof NoToMoreThenThreeEnum;

export enum SleepTimeEnum {
  LESS_THAN_SIX = "LESS_THAN_SIX",
  MORE_THAN_SIX = "MORE_THAN_SIX",
}
export type SleepTime = keyof typeof SleepTimeEnum;

export enum StressLevelEnum {
  NONE = "NONE",
  LOW = "LOW",
  MIDDLE = "MIDDLE",
  HIGH = "HIGH",
}
export type StressLevel = keyof typeof StressLevelEnum;

export const UserHealthInquiryDtoSchema = z.object({
  diet: z.nativeEnum(YesOrNoEnum),
  smoking: z.nativeEnum(NoToMoreThenOneEnum),
  coffee: z.nativeEnum(NoToMoreThenThreeEnum),
  drinking: z.nativeEnum(NoToMoreThenThreeEnum),
  work_out: z.nativeEnum(NoToMoreThenThreeEnum),
  sleep_time: z.nativeEnum(SleepTimeEnum),
  stress_level: z.nativeEnum(StressLevelEnum),
});
export type UserHealthInquiryDto = z.infer<typeof UserHealthInquiryDtoSchema>;
export type UserHealthInquiryKey = keyof UserHealthInquiryDto;

export enum PreferenceShampooEnum {
  NONE = "NONE",
  DETERGENCY = "DETERGENCY",
  NATURAL = "NATURAL",
  COOLING = "COOLING",
  HAIRLOSS_FUNCTION = "HAIRLOSS_FUNCTION",
  VEGAN = "VEGAN",
  FRAGRANCE = "FRAGRANCE",
}
export type PreferenceShampoo = keyof typeof PreferenceShampooEnum;

export enum PreferenceHairEnum {
  STIFF = "STIFF",
  SOFT = "SOFT",
}
export type PreferenceHair = keyof typeof PreferenceHairEnum;

export enum NoneToMoreThenThreeEnum {
  NONE = "NONE",
  LESS_THAN_THREE = "LESS_THAN_THREE",
  MORE_THAN_THREE = "MORE_THAN_THREE",
}
export type NoneToMoreThenThree = keyof typeof NoneToMoreThenThreeEnum;

export enum WashHairCycleEnum {
  ONCE_IN_A_WHILE = "ONCE_IN_A_WHILE",
  ONCE_A_DAY = "ONCE_A_DAY",
  TWICE_A_DAY = "TWICE_A_DAY",
}
export type WashHairCycle = keyof typeof WashHairCycleEnum;

// ========== B2C user inquiry ========== //
export const UserInquiryDtoSchema = z.object({
  age_group: z.nativeEnum(BeconUserTypes.AgeGroupEnum).nullable(),
  gender: z.nativeEnum(BeconUserTypes.UserGenderEnum).nullable(),
  hairloss_type: z.nativeEnum(BeconUserTypes.HairlossTypeEnum).nullable(),
  scalp_issues: z.object({
    issue_1: z.nativeEnum(BeconUserTypes.ScalpIssueTypeEnum).nullable(),
    issue_2: z.nativeEnum(BeconUserTypes.ScalpIssueTypeEnum).nullable(),
    issue_3: z.nativeEnum(BeconUserTypes.ScalpIssueTypeEnum).nullable(),
    level_1: z.number().nullable(),
    level_2: z.number().nullable(),
    level_3: z.number().nullable(),
  }),
  skin_color: z.nativeEnum(BeconUserTypes.SkinColorEnum).nullable(),
  hair_damage_level: z.number().nullable(),
  hairloss_family_history: z.nativeEnum(BeconUserTypes.HairlossFamilyHistoryEnum).nullable(),
  hairloss_level: z.number().nullable(),
  hair_color: z.nativeEnum(BeconUserTypes.HairColorEnum), // default: BLACK
  //범인찾음
  hair_type: z.nativeEnum(HairTypeEnum), // default: STRAIGHT
  lifestyle: z.object({
    dyeing: z.nativeEnum(NoneToMoreThenThreeEnum).nullable(),
    perm: z.nativeEnum(NoneToMoreThenThreeEnum).nullable(),
    wash_hair_cycle: z.nativeEnum(WashHairCycleEnum).nullable(),
    treatment_product: z.nativeEnum(YesOrNoEnum).nullable(),
  }),
  preference: z.object({
    shampoo_1: z.nativeEnum(PreferenceShampooEnum).nullable(),
    shampoo_2: z.nativeEnum(PreferenceShampooEnum).nullable(),
    hair_1: z.nativeEnum(PreferenceHairEnum).nullable(),
  }),
});
export type UserInquiryDto = z.infer<typeof UserInquiryDtoSchema>;
